module.exports = __webpack_public_path__ + "img/marker_three_cyan1.461d427f.png";